window.share_fb = function(url) {
    window.open('https://www.facebook.com/sharer/sharer.php?u='+url,'facebook-share-dialog',"width=626, height=436")
}

window.share_twitter = function(url) {
    window.open('https://twitter.com/intent/tweet?original_referer='+url,'twitter-share-dialog',"width=626, height=436")
}

window.copy_link  = function(url) {
    navigator.clipboard.writeText(url);
}
